// Production builds inject the same instant into the client and prerender process.
export const CONTENT_AS_OF = process.env.REACT_APP_CONTENT_AS_OF || new Date().toISOString();

// Reject Date.parse's permissive formats and silent calendar rollover. A date
// without a time means midnight UTC; datetimes must name their timezone.
function publicationTime(value) {
  if (typeof value !== 'string') return NaN;
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(Z|[+-]\d{2}:\d{2}))?$/.exec(value);
  if (!match) return NaN;
  const [, year, month, day, hour, minute, second, , zone] = match;
  const leap = +year % 4 === 0 && (+year % 100 !== 0 || +year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (+month < 1 || +month > 12 || +day < 1 || +day > days[+month - 1]) return NaN;
  if (hour !== undefined) {
    if (+hour > 23 || +minute > 59 || +(second || 0) > 59) return NaN;
    if (zone !== 'Z' && (+zone.slice(1, 3) > 23 || +zone.slice(4) > 59)) return NaN;
  }
  return Date.parse(hour === undefined ? `${value}T00:00:00Z` : value);
}

export function isPublishable(item, asOf = CONTENT_AS_OF) {
  if (!item || item.draft === true || item.status === 'draft') return false;
  const cutoff = publicationTime(asOf);
  if (!Number.isFinite(cutoff)) return false;
  return ['publishAt', 'publishedAt'].every(field => {
    if (!Object.prototype.hasOwnProperty.call(item, field)) return true;
    const timestamp = publicationTime(item[field]);
    return Number.isFinite(timestamp) && timestamp <= cutoff;
  });
}

export function filterPublished(items, asOf = CONTENT_AS_OF) {
  return items.filter(item => isPublishable(item, asOf));
}
